import script from "./PartnersPrivil.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartnersPrivil.vue?vue&type=script&setup=true&lang=ts"

import "./PartnersPrivil.vue?vue&type=style&index=0&id=0eabeb7e&lang=scss"

const __exports__ = script;

export default __exports__